<template>
  <bg-card class="receivable-summary-card">
    <div :class="`bg-${receivableSummaryColor[status].background} receivable-summary-card__icon`">
      <bg-icon
        size="md"
        :color="receivableSummaryColor[status].icon"
        :name="receivableSummaryIcon[status]"
      />
    </div>
    <div class="receivable-summary-card__content-container">
      <bg-text
        color="grey-semi-dark"
        type="body-sm"
      >
        {{ receivableStatusName[status] }}
      </bg-text>
      <bg-text
        color="grey-dark"
        type="h6"
      >
        {{ centsToReal(amount) }}
      </bg-text>
    </div>
  </bg-card>
</template>

<script setup>
import { BgIcon, BgText, BgCard } from '@transfeeradev/bridge';
import { receivableStatusName } from '@/apps/payin/receivables/constants/receivableStatusName';
import { receivableStatus } from '@/apps/payin/receivables/constants/receivableStatus';
import { centsToReal } from '@/commons/formatters/currency';

defineProps({
  status: {
    type: String,
    required: true
  },
  amount: {
    type: Number,
    required: true,
    default: 0
  }
});

const receivableSummaryColor = {
  [receivableStatus.RECEIVED]: { background: 'green-light', icon: 'green-semi-dark' },
  [receivableStatus.PENDING]: { background: 'yellow-light', icon: 'yellow-semi-dark' },
  [receivableStatus.CANCELED]: { background: 'grey-light', icon: 'grey-semi-dark' }
};

const receivableSummaryIcon = {
  [receivableStatus.RECEIVED]: 'check',
  [receivableStatus.PENDING]: 'clock',
  [receivableStatus.CANCELED]: 'close'
};
</script>

<style scoped>
.receivable-summary-card {
  display: flex;
  border: 1px solid var(--bg-grey-light);
}

.receivable-summary-card__content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: var(--bg-spacing-sm);
}

.receivable-summary-card__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--bg-spacing-lg);
  width: var(--bg-spacing-lg);
  border-radius: var(--bg-border-radius-md);
  cursor: pointer;
}
</style>